import FighterView from "./FighterView"

export default FighterView
